import React from 'react';
// import { Link } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import AbidingByLinks from './AbidingdByLinks';

const NavSubmenu = ({ content, toggleMobileMenu, hideSubmenu }) => {
  return (
    <div className="submenu-wrapper">
      <div className="container">
        <div className="submenu-title-group">
          <h1 className="submenu-title heading-1">{content.title}</h1>
        </div>
        <ul className="submenu-list">
          {content.links
            ? content.links.map((link, i) => {
                switch (link.type) {
                  case 'btn':
                    return (
                      <li key={i} className="btn-wrapper submenu-item" onClick={hideSubmenu}>
                        <Link style={{ background: '#0777db' }} className="submenu-item-link btn-default" to={link.linkTo} onClick={toggleMobileMenu}>
                          <span>{link.linkName}</span>
                        </Link>
                      </li>
                    );
                  case 'internal_link':
                    return (
                      <li key={i} onClick={hideSubmenu} className="submenu-item">
                        <Link className="submenu-item-link text-block-2" to={link.linkTo} onClick={toggleMobileMenu}>
                          {link.linkName}
                        </Link>
                      </li>
                    );
                  case 'external_link':
                    return (
                      <li key={i} onClick={hideSubmenu} className="submenu-item">
                        <a href={link.linkTo} target="_blank" className="submenu-item-link">
                          {link.linkName}
                        </a>
                      </li>
                    );
                }
              })
            : null}
        </ul>
        <div className="contact-us-wrapper">
          <a href={content.cta.href} className="contact-us-link">
            <div className="contact-us-content">
              <p className="assist-text">{content.cta.slogan}</p>
              <img className="phone-icon-img" src="/images/nav_footer/dropdown-menu-call-bubble.svg" alt="call-icon-dark" />
              <p className="phone-number"> {content.cta.phone} </p>
              <img className="contact-us-rep-img" src="/images/nav_footer/dropdown-menu-call-lady.svg" alt="lady-icon" />
            </div>
            <img className="contact-us-img-bg" src="/images/nav_footer/dropdown-menu-phone-bg.svg" alt="phone-icon" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default NavSubmenu;

//CSS Structure

/* 

.submenu-wrapper{
  .container{
    .submenu-title-group{
      .submenu-title{
      }
    }
    .submenu-list{
      .submenu-item{
        .submenu-link{
        }
        &.btn-wrapper{
          &.btn-default{
          }
        }
      }
    }
    .contact-us-wrapper{
      .contact-us-link{
        .contact-us-content{
          .assist-text{
          }
          .phone-img-wrapper{
          }
          .phone-icon-img{
          }
          .contact-us-rep-img{
          }
        }
        .contact-us-img-bg{
        }
      }
    }
  }
}


*/
